import {
  FETCH_ACCOUNT_GEOZONE_INIT,
  FETCH_ACCOUNT_GEOZONE_SUCCESS,
  FETCH_ACCOUNT_GEOZONE_FAILURE,
  FETCH_ACCOUNT_GEOZONE_CH_INIT,
  FETCH_ACCOUNT_GEOZONE_CH_SUCCESS,
  FETCH_ACCOUNT_GEOZONE_CH_FAILURE,
  RESET_ACCOUNT_GEOZONE,
  SAVE_ACCOUNT_GEOZONE_INIT,
  SAVE_ACCOUNT_GEOZONE_SUCCESS,
  SAVE_ACCOUNT_GEOZONE_FAILURE,
  UPDATE_ACCOUNT_GEOZONE_INIT,
  UPDATE_ACCOUNT_GEOZONE_SUCCESS,
  UPDATE_ACCOUNT_GEOZONE_FAILURE,
  DELETE_ACCOUNT_GEOZONE_INIT,
  DELETE_ACCOUNT_GEOZONE_SUCCESS,
  DELETE_ACCOUNT_GEOZONE_FAILURE,
  RESET_MODAL,
  RESET_MODAL_FILE,
  FETCH_DOWNLOAD_ACCOUNT_GEOZONE_SUCCESS,
  FETCH_DOWNLOAD_ACCOUNT_GEOZONE_FAILURE,
  FETCH_DOWNLOAD_ACCOUNT_GEOZONE_INIT,
  FETCH_UPLOAD_ACCOUNT_GEOZONE_SUCCESS,
  FETCH_UPLOAD_ACCOUNT_GEOZONE_FAILURE,
  FETCH_UPLOAD_ACCOUNT_GEOZONE_INIT,
  FETCH_ACCOUNT_GEOZONE_NO_LOADING_INIT,
  FETCH_ACCOUNT_GEOZONE_NO_LOADING_SUCCESS,
  FETCH_ACCOUNT_GEOZONE_NO_LOADING_FAILURE,
  ACTIVE_ACCOUNT_GEOZONE_INIT,
  ACTIVE_ACCOUNT_GEOZONE_SUCCESS,
  ACTIVE_ACCOUNT_GEOZONE_FAILURE
} from './types';
import API from './api';

export function resetModalFileGeozoneAccount() {
  return {
    type: RESET_MODAL_FILE
  };
}

export function resetModalGeozone() {
  return {
    type: RESET_MODAL
  };
}

export function resetAccountGeozone() {
  return {
    type: RESET_ACCOUNT_GEOZONE
  };
}

/* Fetch geozone */

function fetchApiSuccess(data) {
  return {
    type: FETCH_ACCOUNT_GEOZONE_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  console.log(error);
  return {
    type: FETCH_ACCOUNT_GEOZONE_FAILURE,
    payload: error
  };
}

function fetchApiInit(loading) {
  return {
    type: FETCH_ACCOUNT_GEOZONE_INIT,
    loading: loading
  };
}

export function fetchAccountGeozoneApi(obj, loading) {
  return async dispatch => {
    dispatch(fetchApiInit(loading));
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

/* Fetch geozone CHARACTERISTIC */

function fetchApiChSuccess(data) {
  return {
    type: FETCH_ACCOUNT_GEOZONE_CH_SUCCESS,
    payload: data
  };
}

function fetchApiChFailure(error) {
  console.log(error);
  return {
    type: FETCH_ACCOUNT_GEOZONE_CH_FAILURE,
    payload: error
  };
}

function fetchApiChInit(loading) {
  return {
    type: FETCH_ACCOUNT_GEOZONE_CH_INIT,
    loading: loading
  };
}

export function fetchAccountGeozoneChApi(obj, loading) {
  return async dispatch => {
    dispatch(fetchApiChInit(loading));
    try {
      let data = await API.data.getCharacteristic(obj);
      dispatch(fetchApiChSuccess(data));
    } catch (error) {
      dispatch(fetchApiChFailure(error));
    }
  };
}

/* Account geozone no loading */

function fetchApiNoLoadingSuccess(data, concat) {
  return {
    type: FETCH_ACCOUNT_GEOZONE_NO_LOADING_SUCCESS,
    payload: data,
    concat: concat
  };
}

function fetchApiNoLoadingFailure(error) {
  console.log(error);
  return {
    type: FETCH_ACCOUNT_GEOZONE_NO_LOADING_FAILURE,
    payload: error
  };
}

function fetchApiNoLoadingInit() {
  return {
    type: FETCH_ACCOUNT_GEOZONE_NO_LOADING_INIT
  };
}

export function fetchAccountGeozoneNoLoadingApi(obj) {
  return async dispatch => {
    dispatch(fetchApiNoLoadingInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchApiNoLoadingFailure(error));
    }
  };
}

/* geozone Save (Async) */

function saveApiSuccess(data) {
  return {
    type: SAVE_ACCOUNT_GEOZONE_SUCCESS,
    payload: data
  };
}

function saveApiFailure(error) {
  return {
    type: SAVE_ACCOUNT_GEOZONE_FAILURE,
    errorSave: error
  };
}

function saveApiInit() {
  return {
    type: SAVE_ACCOUNT_GEOZONE_INIT
  };
}

export function handleGeozone(data) {
  return async dispatch => {
    dispatch(saveApiInit());
    try {
      const resp = await API.data.handleGeozone(data);
      return dispatch(saveApiSuccess(resp));
    } catch (error) {
      return dispatch(saveApiFailure(error));
    }
  };
}

/* Geozone Update (Async) */

function updateApiSuccess(data) {
  return {
    type: UPDATE_ACCOUNT_GEOZONE_SUCCESS,
    payload: data
  };
}

function updateApiFailure(error) {
  return {
    type: UPDATE_ACCOUNT_GEOZONE_FAILURE,
    errorupdate: error
  };
}

function updateApiInit() {
  return {
    type: UPDATE_ACCOUNT_GEOZONE_INIT
  };
}

export function handleUpdateGeozone(data) {
  return async dispatch => {
    dispatch(updateApiInit());
    try {
      const resp = await API.data.handleUpdateGeozone(data);
      return dispatch(updateApiSuccess(resp));
    } catch (error) {
      return dispatch(updateApiFailure(error));
    }
  };
}

/* Geozone Delete (Async) */

function deleteApiSuccess(data) {
  return {
    type: DELETE_ACCOUNT_GEOZONE_SUCCESS,
    payload: data
  };
}

function deleteApiFailure(error) {
  return {
    type: DELETE_ACCOUNT_GEOZONE_FAILURE,
    errordelete: error
  };
}

function deleteApiInit() {
  return {
    type: DELETE_ACCOUNT_GEOZONE_INIT
  };
}

export function handleDeleteGeozone(data) {
  return async dispatch => {
    dispatch(deleteApiInit());
    try {
      const resp = await API.data.handleDeleteGeozone(data);
      return dispatch(deleteApiSuccess(resp));
    } catch (error) {
      return dispatch(deleteApiFailure(error));
    }
  };
}

/* get download file */

function fetchDownloadApiSuccess(data) {
  return {
    type: FETCH_DOWNLOAD_ACCOUNT_GEOZONE_SUCCESS,
    payload: data
  };
}

function fetchDownloadApiFailure(error) {
  console.log(error);
  return {
    type: FETCH_DOWNLOAD_ACCOUNT_GEOZONE_FAILURE,
    payload: error
  };
}

function fetchDownloadApiInit() {
  return {
    type: FETCH_DOWNLOAD_ACCOUNT_GEOZONE_INIT
  };
}

export function fetchAccountGeozoneDownloadApi(item) {
  return async dispatch => {
    dispatch(fetchDownloadApiInit());
    try {
      let data = await API.data.handleGeozoneDownload(item);
      dispatch(fetchDownloadApiSuccess(data));
    } catch (error) {
      dispatch(fetchDownloadApiFailure(error));
    }
  };
}

/* get upload file */

function fetchUploadApiSuccess(data) {
  return {
    type: FETCH_UPLOAD_ACCOUNT_GEOZONE_SUCCESS,
    payload: data
  };
}

function fetchUploadApiFailure(error) {
  console.log(error);
  return {
    type: FETCH_UPLOAD_ACCOUNT_GEOZONE_FAILURE,
    payload: error
  };
}

function fetchUploadApiInit() {
  return {
    type: FETCH_UPLOAD_ACCOUNT_GEOZONE_INIT
  };
}

export function fetchAccountGeozoneUploadApi(group, tags) {
  return async dispatch => {
    dispatch(fetchUploadApiInit());
    try {
      let data = await API.data.handleGeozoneUpload(group, tags);
      dispatch(fetchUploadApiSuccess(data));
    } catch (error) {
      dispatch(fetchUploadApiFailure(error));
    }
  };
}

/* Active Geozone (Async) */

function activeApiSuccess(data) {
  return {
    type: ACTIVE_ACCOUNT_GEOZONE_SUCCESS,
    payload: data
  };
}

function activeApiFailure(error) {
  return {
    type: ACTIVE_ACCOUNT_GEOZONE_FAILURE,
    errordelete: error
  };
}

function activeApiInit() {
  return {
    type: ACTIVE_ACCOUNT_GEOZONE_INIT
  };
}

export function handleActiveGeozone(data) {
  return async dispatch => {
    dispatch(activeApiInit());
    try {
      const resp = await API.data.handleActiveGeozone(data);
      return dispatch(activeApiSuccess(resp));
    } catch (error) {
      return dispatch(activeApiFailure(error));
    }
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/account_geozone/index.js